<div class="tab-pane" role="tabpanel" id="clasificacion">
    <fieldset id="agregar_clasificacion" class="">
        <div class="step_section">
            <div class="row" id="row">
                <div class="col-md-12" id="content">
                    <div class="form-horizontal">
                        <form [formGroup]="form">
                            <h3 class="form-signin-heading"><strong>Clasificacion(es) Construccion(es) predominante(s)</strong></h3>
                            <hr />

                            <div class="form-group">
                                <label for="clasificacion" class="col-md-2" align="left" style="padding-top: 20px;">Clasificaci&oacute;n</label>
                                <div class="col-md-3">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="Clasificaci&oacute;n" id="clasificacion" name="clasificacion" formControlName="clasificacion" >
                                    </mat-form-field>
                                </div>
                                <div class="col-md-2"></div>
                                <label for="metro" class="col-md-2" align="left" style="padding-top: 20px;">Metros (m2)</label>
                                <div class="col-md-3">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="Metros" id="metro" name="metro" formControlName="metro" >
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="col-md-12" style="padding-top: 30px" align="center">
                                <button mat-raised-button color="primary" style="padding-top: 5px" id="ingreso_cproyecto" (click)="add_clasificacion()">
                                        Agregar Clasificacion
                                    <mat-icon aria-label="icon">add_circle_outline</mat-icon>
                                </button>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
            <div class="datatable_antecedentes">
                <ngx-datatable class="material expandable" [messages]="''" [rows]="rows" [columnMode]="'force'" [headerHeight]="'auto'" [footerHeight]="'auto'" [rowHeight]="'auto'">
                    <ngx-datatable-column>
                        <ng-template ngx-datatable-header-template>
                            <span>CLASIFICACION</span>
                        </ng-template>
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            {{row.clasificacion}}
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column>
                        <ng-template ngx-datatable-header-template>
                            <span>METRO</span>
                        </ng-template>
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            {{row.metro}}
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column>
                        <ng-template ngx-datatable-header-template>
                            <span>OPCIONES</span>
                        </ng-template>
                        <ng-template let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template>
                            <span (click)="get_clasificacion(rowIndex)" style="padding-right: 5px;"><i class="glyphicon glyphicon-pencil"></i></span>
                            <span (click)="delete_clasificacion(rowIndex)"><i class="glyphicon glyphicon-trash"></i></span>
                        </ng-template>
                    </ngx-datatable-column>

                </ngx-datatable>


            </div>
        </div>
    </fieldset>

    <ng-template #openModal>
        <h2 mat-dialog-title>Informaci&oacute;n de la Clasificacion(es) Construccion(es) Predominante(s)</h2>
        <mat-dialog-content>
            <div class="form-horizontal">
                <div class="form-group">
                    <label class="col-md-4 control-label" for="clasificaciones">Clasificaciones</label>
                    <div class="col-md-6">
                        <input id="id" name="id" type="hidden" placeholder="id" class="form-control input-md" [(ngModel)]="temp_clasif.id">
                        <input id="clasificacion" name="clasificacion" type="text" placeholder="clasificacion" class="form-control input-md" [(ngModel)]="temp_clasif.clasificacion">
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="metro">M2</label>
                    <div class="col-md-6">
                        <input id="metro" name="metro" type="text" placeholder="metro" class="form-control input-md" [(ngModel)]="temp_clasif.metro">
                    </div>
                    <div class="col-md-2"></div>
                </div>

            </div>
        </mat-dialog-content>
        <mat-dialog-actions align="end">
            <button matDialogClose mat-raised-button color="warn" id="clean_ingreso_clasificacion" data-dismiss="modal" (click)="cleanData()">Cancelar</button>
            <button mat-raised-button color="primary" id="ingreso_ampliacion" (click)="saveclasificacion()">Ingresar Clasificacion <i class="fa fa-user-o " aria-hidden="true "></i></button>
        </mat-dialog-actions>
    </ng-template>
    <!--End Material Dialog-->
</div>

<ng-template #openModalNODATA>
    <h2 mat-dialog-title>Ingrese datos</h2>
    <mat-dialog-content>
       No ingreso ningun dato del clasificación.
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button matDialogClose mat-raised-button color="warn" id="clean_ingreso_propiet" data-dismiss="modal" (click)="cleanData()">Aceptar</button>
    </mat-dialog-actions>
</ng-template>


<div class="separator"></div>